// extracted by mini-css-extract-plugin
export default {"iframe_modal":"style_iframe_modal__e0Auw","iframe":"style_iframe__CP4H0"};